<div class="top-wrapper">
	<div class="icon-wrapper"><i class="cp-icon-color-1" [ngClass]="iconClass"></i></div>
	<div class="text-wrapper">
		<div class="text">{{text}}</div>
		<div *ngIf="additionalText" class="additional-text">{{additionalText}}</div>
	</div>
</div>
